export const blogCopy = {
  eyebrow: "Blog",
  title: "Tutorial n8n, AI Agent & Automation",
  description:
    "Panduan praktis berbahasa Indonesia untuk membangun automation, AI agent, dan SaaS — langkah demi langkah.",
  searchPlaceholder: "Cari artikel…",
  searchLabel: "Cari artikel",
  searchSubmit: "Cari",
  tagFilter: (tag: string) => `Tag: ${tag}`,
  clearFilter: "Hapus filter",
  empty: "Tidak ada artikel yang cocok.",
  readingTime: (minutes: number) => `${minutes} menit baca`,
  previous: "Sebelumnya",
  next: "Berikutnya",
  pageOf: (page: number, total: number) => `Halaman ${page} dari ${total}`,
  latestEyebrow: "Dari blog",
  latestTitle: "Artikel terbaru",
  viewAll: "Lihat semua artikel",
  relatedTitle: "Artikel terkait",
  tagsLabel: "Tag",
  shareCopy: "Salin link",
  shareCopied: "Link disalin",
  notFoundTitle: "Artikel tidak ditemukan",
  notFoundDescription: "Artikel ini mungkin sudah dipindahkan.",
  backToBlog: "Kembali ke blog",
} as const;
